
import {throwError as observableThrowError, Subject } from 'rxjs';
import {finalize, catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs';

import { LoginService } from '../../login/shared/login.service';
import { environment } from './../../../environments/environment';

@Injectable()
export class IndiSetService {
    private refreshSubject = new Subject<any>();

    constructor(
        private http: HttpClient,
        private authenticate: LoginService,
    ) { }


    /* GET METHODS START */
    getIndividualSettingList(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/individual_employment_setting/all?limit='+data.limit+'&page='+data.page+'&category='+data.category+'&branch='+data.branch+'&avail_status='+data.avail_status+'&temp_name='+data.temp_name+'&search_query='+data.search_query, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    getStaffSettings(id: number) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/individual_employment_setting/detail_temp/'+id, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    /* GET METHODS END */


    /* POST METHODS START */
    addIndividualSetting(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.post(environment.SERVER_URL + '/individual_employment_setting/', data, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
                        // .finally(() => {
                        //     this.refreshSubject.next();
                        // });
    }
    /* POST METHODS END */



    /* PUT METHODS START */
    updateMultiple(data: any) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.put(environment.SERVER_URL + '/individual_employment_setting/update_multiple', data, options ).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.refreshSubject.next();
                        }),);
    }

    updateIndividualSettings(data: any) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.put(environment.SERVER_URL + '/individual_employment_setting/', data, options ).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    excludeInSummary(data: any) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.put(environment.SERVER_URL + '/individual_employment_setting/summary_excluded?staff_id='+data.staff_id+'&summary_excluded='+data.flag, options ).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.refreshSubject.next();
                        }),);
    }
    /* PUT METHODS END */

    // getGMSdata(id: number) {
    //     const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
    //     const options = { headers: headers };

    //     return this.http.get(environment.SERVER_URL + '/individual_employment_setting/gmsData/' + id, options).pipe(
    //         map(this.extractData),
    //         catchError(this.handleError),);
    // }

    /* SUBSCRIPTION METHODS START */
    onRefresh() {
        return this.refreshSubject.asObservable();
    }
    /* SUBSCRIPTION METHODS END */

    private extractData(res: any) {
        let body = res;
        return body.data || {};
    }

    private handleError (error: any) {
        let errMsg: string;
        if (error) {
        const body = error || '';
        const err = body.error || JSON.stringify(body);
        errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
        errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return observableThrowError(errMsg);
    }
}